export default __webpack_public_path__ + "static/media/L-A-wrong.21cb6439.png";